import React from 'react'
import { FaLinkedinIn, FaBehance, FaInstagram } from 'react-icons/fa'
import styled from 'styled-components'

const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 120px;
    .navbar {
        display: flex;
        gap: 24px;
        font-weight: 500;
    }
    .social {
        display: flex;
        gap: 16px;
        .icon {
            font-size: 24px;
        }
    }
    @media (max-width: 1100px) {
        flex-direction: column;
        gap: 45px;
        .navbar {
            flex-direction: column;
            align-items: center;
        }
        .social {
            gap: 45px;
        }
    }
`

function Footer() {
  return (
      <Wrapper>
            <div>
                <h2>Lidielly Brandão</h2>
                <p>Social Media e Designer</p>
            </div>
            <div className='navbar'>
                <a href='#services'>Serviços</a>
                <a href='#portfolio'>Portfólio</a>
                <a href='#contactMe'>Fale Comigo</a>
            </div>
            <div className='social'>
                <a target='_blank' rel='noreferrer' href='https://www.linkedin.com/in/lindielly-brand%C3%A3o-261a96187/'>
                    <FaLinkedinIn className="icon" />  
                </a>
                <a target='_blank' rel='noreferrer' href='https://www.behance.net/lindiellybrandao'>
                    <FaBehance className="icon" />
                </a>
                <a target='_blank' rel='noreferrer' href='https://www.instagram.com/l1ndielly/'>
                    <FaInstagram className="icon" />
                </a>
            </div>
      </Wrapper>
  );
}

export default Footer;